var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Rating"},[_c('span',{staticClass:"Rating-text"},[_vm._v(" "+_vm._s(_vm.rating.score)+" ")]),_c('span',{staticClass:"Rating-star f2m-star",class:{
            'Rating-star--active': _vm.rating.score >= 0.5,
        }}),_c('span',{staticClass:"Rating-star f2m-star",class:{
            'Rating-star--active': _vm.rating.score >= 1.5,
        }}),_c('span',{staticClass:"Rating-star f2m-star",class:{
            'Rating-star--active': _vm.rating.score >= 2.5,
        }}),_c('span',{staticClass:"Rating-star f2m-star",class:{
            'Rating-star--active': _vm.rating.score >= 3.5,
        }}),_c('span',{staticClass:"Rating-star f2m-star",class:{
            'Rating-star--active': _vm.rating.score >= 4.5,
        }}),_c('span',{staticClass:"Rating-text"},[_vm._v(" "+_vm._s(_vm.rating.total)+" "+_vm._s(_vm.$t('personal-account.ride.rating.reviews'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }